import {
  FETCH_LICENCIAS,
  FETCH_SECUESTROS,
  FILTER_LICENCIA,
  FILTER_SECUESTRO,
  FOTO_LICENCIA,
  GET_ALL_INFRACCIONES,
  GET_ALL_SECUESTROS,
  GET_ALL_VEHICULOS,
  GET_DETAIL_SECUESTRO,
  INGRESO_DETALLES,
  INGRESO_FOTO,
  INGRESO_LICENCIA,
  LIMPIAR_FOTO,
  LIMPIAR_FOTO_LICENCIA,
  LOGIN,
  OFICIO_POLICIAL,
  SEARCH_LICENCIA,
  SET_AUTHENTICATED,
  UP_ACTA,
  UPDATE_PAGE,
  UPDATE_PAGE_LICENCIAS,
  UPDATE_TOTALS_BY_FILTER,
  VEHICLE_TYPE,
  UPDATE_LIMIT,
  UPDATE_LIMIT_LICENCIAS,
  UPDATE_TOTALS_BY_FILTER_LICENCIA,
  GET_DETAIL_REQUEST,
  GET_DETAIL_FAILURE,
} from "../actions";

const initialState = {
  secuestros: [],
  vehiculos: [],
  currentPage: 1,
  totalPages: 1,
  detail: {},
  loadingDetail: false,
  infracciones: [],
  ingresoDetalles: {},
  ingresoFoto: "",
  datosConfirmarIngreso: {},
  currentUserId: 0,
  tipoCurrentUser: 0,
  isAuthenticated: false,
  selectedFilter: "todos",
  vehicleType: "todos",
  limitSecuestros: 9,
  totalsByFilter: {
    todos: 0,
    ingresados: 0,
    egresados: 0,
    "a compactar": 0,
    compactados: 0,
  },

  licencias: [],
  licenciaFound: null,
  currentPageLicencia: 1,
  totalPagesLicencia: 1,
  dataIngresoLicencia: {},
  fotoLicencia: null,
  selectedFilterLicencia: "todas",
  limitLicencias: 9,
  totalsByFilterLicencia: {
    todas: 0,
    ingresadas: 0,
    egresadas: 0,
  },

};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SECUESTROS:
      return { ...state, secuestros: action.payload };
    case UPDATE_TOTALS_BY_FILTER: {
      const total = action.payload[state.selectedFilter] ?? 0;

      return {
        ...state,
        totalsByFilter: action.payload,
        totalPages: Math.max(1, Math.ceil(total / state.limitSecuestros)),
      };
    }
    case UPDATE_PAGE:
      return { ...state, currentPage: action.payload };
    case UPDATE_LIMIT: {
      const total = state.totalsByFilter[state.selectedFilter] ?? 0;

      return {
        ...state,
        limitSecuestros: action.payload,
        totalPages: Math.max(1, Math.ceil(total / action.payload)),
      };
    }
    case FILTER_SECUESTRO: {
      const total = state.totalsByFilter[action.payload] ?? 0;

      return {
        ...state,
        selectedFilter: action.payload,
        totalPages: Math.max(1, Math.ceil(total / state.limitSecuestros)),
      };
    }
    case VEHICLE_TYPE:
      return { ...state, vehicleType: action.payload };
    case GET_DETAIL_REQUEST:
      return { ...state, loadingDetail: true, detail: {} };
    case GET_DETAIL_SECUESTRO:
      return { ...state, loadingDetail: false, detail: action.payload };
    case GET_DETAIL_FAILURE:
      return { ...state, loadingDetail: false };
    case GET_ALL_VEHICULOS:
      return { ...state, vehiculos: action.payload };
    case GET_ALL_SECUESTROS:
      return { ...state, secuestros: action.payload };
    case GET_ALL_INFRACCIONES:
      return { ...state, infracciones: action.payload };
    case OFICIO_POLICIAL:
      return {
        ...state,
        datosConfirmarIngreso: {
          vehiculoDominio: action.payload.dominio,
          vehiculoTipo: action.payload.tipovh,
          vehiculoMarca: action.payload.marcavh,
          vehiculoModelo: action.payload.modelovh,
          infractorNombre: action.payload.nombreCompleto,
          infractorDni: action.payload.dni,
          infractorCuil: action.payload.cuil,
          infractorSexo: action.payload.sexo,
          /* infracciones: action.payload.infracciones, */
        },
      };
    case INGRESO_DETALLES:
      return { ...state, ingresoDetalles: action.payload };
    case INGRESO_FOTO:
      return { ...state, ingresoFoto: action.payload };
    case LIMPIAR_FOTO:  // Nueva acción
      return { ...state, ingresoFoto: null };
    case UP_ACTA:
      // Concatenamos ambos valores
      const fechaHoraFinal = `${action.payload.fecha}, ${action.payload.hora}`;
      return {
        ...state,

        datosConfirmarIngreso: {

          actaId: action.payload.id,

          actaNro: action.payload.nroActa,
          /* actaInspector: action.payload.inspector, */ // Este inspector es un string (nombre)
          actaLugar: action.payload.lugar,
          actaFecha_hora: fechaHoraFinal,
          vehiculoDominio: action.payload.vehiculo.dominio,
          vehiculoTipo: action.payload.vehiculo.tipo,
          vehiculoMarca: action.payload.vehiculo.marca,
          vehiculoModelo: action.payload.vehiculo.modelo,
          infractorNombre: action.payload.infractor?.nombre,
          infractorDni: action.payload.infractor?.dni,
          /* infractorCuil: action.payload.infractor?.cuilcuit, */ //No trae cuil
          /* infractorSexo: action.payload.infractor?.sexo, */ //No trae sexo
          infracciones: action.payload.infracciones.map((item) => ({ //Cuando es por búsqueda es payload.infracciones y cuando es por botón es payload.infraccion
            descrip: item.descripcion,
            digesto: item.digesto,
          })),
        },
      };
    case LOGIN:
      return {
        ...state,
        currentUserId: action.payload.userId,
        tipoCurrentUser: action.payload.tipo,
      };
    case SET_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: action.payload, // Actualiza el estado de autenticación
      };


    case FETCH_LICENCIAS:
      return { ...state, licencias: action.payload };
    case UPDATE_TOTALS_BY_FILTER_LICENCIA: {
      const total = action.payload[state.selectedFilterLicencia] ?? 0;

      return {
        ...state,
        totalsByFilterLicencia: action.payload,
        totalPagesLicencia: Math.max(1, Math.ceil(total / state.limitLicencias)),
      };
    }
    case SEARCH_LICENCIA:
      return { ...state, licenciaFound: action.payload };
    case FILTER_LICENCIA: {
      const total = state.totalsByFilterLicencia[action.payload] ?? 0;

      return {
        ...state,
        selectedFilterLicencia: action.payload,
        totalPagesLicencia: Math.max(1, Math.ceil(total / state.limitLicencias)),
      };
    }
    case UPDATE_PAGE_LICENCIAS:
      return { ...state, currentPageLicencia: action.payload };
    case UPDATE_LIMIT_LICENCIAS: {
      const total = state.totalsByFilterLicencia[state.selectedFilterLicencia] ?? 0;

      return {
        ...state,
        limitLicencias: action.payload,
        totalPagesLicencia: Math.max(1, Math.ceil(total / action.payload)),
      };
    }
    case INGRESO_LICENCIA:
      return { ...state, dataIngresoLicencia: action.payload };
    case FOTO_LICENCIA:
      return { ...state, fotoLicencia: action.payload };
    case LIMPIAR_FOTO_LICENCIA:
      return { ...state, fotoLicencia: null };
    default:
      return { ...state };
  }
};
